import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';
import { faEdit, faFileExport } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEqual } from 'lodash';

import EditProductsViewModal from 'components/global_products/edit_view/EditProductsViewModal';
import ProductStatus from 'lib/enums/ProductStatus';

const STATUS_OPTIONS = [
  {
    label: 'Uncategorized',
    value: [ProductStatus.UNCATEGORIZED],
    key: 'uncategorized',
  },
  { label: 'Categorized', value: [ProductStatus.CATEGORIZED], key: 'categorized' },
  { label: 'All', value: [], key: 'all' },
];

function GlobalProductsHeader({
  selectedStatus,
  setSelectedStatus,
  setCurrentPage,
  clearSelectedIDs,
  disabled = false,
  handleExportGlobalProducts,
  productsExporting = false,
}) {
  const [showEditViewModal, setShowEditViewModal] = useState(false);

  return (
    <Row>
      <Col>
        <ButtonGroup>
          {STATUS_OPTIONS.map(option => (
            <Button
              key={option.key}
              variant={isEqual(selectedStatus, option.value) ? 'primary' : 'outline-primary'}
              onClick={() => {
                clearSelectedIDs();
                setCurrentPage(1);
                setSelectedStatus(option.value);
              }}
              disabled={disabled}
            >
              {option.label}
            </Button>
          ))}
        </ButtonGroup>
      </Col>
      <Col className="d-flex justify-content-end">
        {handleExportGlobalProducts ? (
          <Button
            className="mr-2"
            variant="outline-primary"
            onClick={handleExportGlobalProducts}
            disabled={productsExporting}
          >
            <FontAwesomeIcon icon={faFileExport} className="mr-2" />
            Export
          </Button>
        ) : null}
        <Button onClick={() => setShowEditViewModal(true)}>
          <FontAwesomeIcon icon={faEdit} className="mr-2" />
          Edit View
        </Button>
      </Col>
      <EditProductsViewModal show={showEditViewModal} onHide={setShowEditViewModal} />
    </Row>
  );
}

GlobalProductsHeader.propTypes = {
  disabled: PropTypes.bool,
  selectedStatus: PropTypes.array,
  setCurrentPage: PropTypes.func,
  clearSelectedIDs: PropTypes.func,
  setSelectedStatus: PropTypes.func,
  handleExportGlobalProducts: PropTypes.func,
  productsExporting: PropTypes.bool,
};

export default GlobalProductsHeader;
